import Konsul from "@/modules/Konsul/components/Konsul";
import ConsultantManagement from "@/modules/Konsul/ConsultantManagement.vue";
import ConsulActivity from "@/modules/Konsul/ConsulActivity.vue";
import ConsultantForm from "@/modules/Konsul/ConsultantManagementForm.vue";
import ConsulHistory from "@/modules/Konsul/ConsulHistory.vue";
import ConsulChat from "@/modules/Konsul/ConsulChat.vue";
import ConsulTimeActive from "@/modules/Konsul/ConsulTimeActive.vue";

export default [
    {
        path: "/konsul",
        name: "Konsul",
        component: Konsul,
    },
    {
        path: "/konsul/management",
        name: "Consultant Management",
        component: ConsultantManagement,
    },
    {
        path: "/konsul/activity",
        name: "Consul Activity",
        component: ConsulActivity,
    },
    {
        path: "/konsul/consultant-form",
        name: "Consultant Form",
        component: ConsultantForm,
    },
    {
        path: "/konsul/history",
        name: "Consul History",
        component: ConsulHistory,
    },
    {
        path: "/konsul/chat",
        name: "Consul Chat",
        component: ConsulChat,
    },
    {
        path: "/konsul/time-active",
        name: "Consul Time Active",
        component: ConsulTimeActive,
    },
];



// WEBPACK FOOTER //
// ./src/modules/konsul/router/konsul.js